import { Col, Row } from 'antd';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import FreezeManagement from './components/FreezeManagement';

const MemberFreezeManagement = () => {
  return (
    <Row>
      <Col span={24}>
        <PageHeader
          title="會員凍結管理"
          breadcrumbs={[
            {
              name: '會員管理',
            },
            {
              name: '會員凍結管理',
            },
          ]}
        />
        <FreezeManagement />
      </Col>
    </Row>
  );
};

export default MemberFreezeManagement;
